import React, { useState } from "react";
import DashboardLayout from "layouts/DashboardLayout";
import MainCloudCounter from "pages/cloud-counter";
import Projects from "pages/home";
import { Route, Routes } from "react-router-dom";
import AppForm from "pages/app-form/AppForm";

const Router = () => {
    const [joyrideStart, setJoyrideStart] = useState(false);
    const [activeCountsTab, setActiveCountsTab] = useState("software");

    return (
        <Routes>
            <Route
                path=""
                element={
                    <DashboardLayout
                        joyrideStart={joyrideStart}
                        setActiveCountsTab={setActiveCountsTab}
                        activeCountsTab={activeCountsTab}
                    />
                }
            >
                <Route
                    path=""
                    element={
                        <Projects
                            joyrideStart={joyrideStart}
                            setJoyrideStart={setJoyrideStart}
                        />
                    }
                />
                <Route
                    path="cloud-counter"
                    element={
                        <MainCloudCounter
                            activeTab={activeCountsTab}
                            setActiveTab={setActiveCountsTab}
                        />
                    }
                />
            </Route>

            <Route path="/app-form" element={<AppForm />} />
        </Routes>
    );
};

export default Router;
